import { render } from "./BankAccountSelection.vue?vue&type=template&id=8e5ef774"
import script from "./BankAccountSelection.vue?vue&type=script&lang=js"
export * from "./BankAccountSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__